import type { AppModule } from '../registry';
import { IconOffice } from '../../components/icons';
import { GetStartedView } from './GetStartedView';
import { BookingsView } from './BookingsView';
import { UsageView } from './UsageView';
import { ProfileView } from './ProfileView';

// Office app-module. Phase 3 (#41): F1 bookings + F2 usage. Phase 4 (#42): F3 profile editing,
// schema-driven via the BFF (audience-filtered schema + field-level editable enforcement).
export const office_module: AppModule = {
  app_code: 'captomi_office',
  label: 'Office',
  blurb: 'Your AI receptionist — business profile, bookings, and plan usage.',
  icon: <IconOffice />,
  accent: '#2e8b57',
  nav: [
    // Get Started is first → it's the Office landing (first_route uses nav[0]).
    { path: 'get-started', label: 'Get Started', element: <GetStartedView /> },
    { path: 'profile', label: 'Profile', element: <ProfileView /> },
    { path: 'bookings', label: 'Bookings', element: <BookingsView /> },
    { path: 'usage', label: 'Usage', element: <UsageView /> },
  ],
};
